export default __webpack_public_path__ + "static/media/demo-1-raw.11cce9a6.jpg";